import { MdChevronLeft } from 'react-icons/md';
import { useHistory } from 'react-router-dom';

import { Container, ItemMenu, TextItem } from './styles';

function PolicyMenu() {
  const history = useHistory();

  return (
    <Container>
      <ItemMenu
        onClick={() => {
          history.push('/meus-contratros');
        }}
      >
        <MdChevronLeft size="18" />
        <TextItem>Meus Contratos</TextItem>
      </ItemMenu>
    </Container>
  );
}

export default PolicyMenu;
